/* FLGNTLT — Warenkorb-Gestaltung, Begleitskript. Bewusst klein.
 *
 * Einzige Aufgabe bisher: den Gesamtbetrag neben "Zur Kasse" stellen. Er darf NICHT ins Markup,
 * weil die Abnahme (warenkorb-abnahme.mjs) den innerText des Knopfes liest und gegen "Zur Kasse"
 * vergleicht — "Zur Kasse 120,00 €" im Text faerbt jede Geraeteklasse rot. Also wandert der Betrag
 * in eine Custom-Property und wird vom CSS als ::after gezeichnet.
 *
 * Dawn ersetzt beim Mengenwechsel den kompletten .drawer__inner (cart-drawer.js) bzw. die beiden
 * .js-contents auf /cart (cart.js). Gemerkte Knoten sind danach Geister (K201) — deshalb wird bei
 * jedem Lauf frisch gesucht und ein MutationObserver haengt an document.body, nicht am Panel.
 */
(function () {
  'use strict';

  // Knopf und Summe gehoeren PAARWEISE zusammen: Ausklapp zu Ausklapp, /cart zu /cart. Bis 30.09.2026
  // nahm `querySelector('#CartDrawer-Checkout, #checkout')` den ERSTEN Treffer im Dokument — auf /cart
  // liegt der Ausklapp vor dem Inhalt, also bekam dort nur der Drawer-Knopf den Betrag und der
  // sichtbare Kasse-Knopf der Seite blieb leer (Screenshot 24.09.: „ZUR KASSE" ohne Betrag).
  // `#fw-checkout-mobil` ist der zweite Kasse-Knopf der festen Leiste auf /cart (Paket WD5).
  var PAARE = [
    ['#CartDrawer-Checkout', '.drawer .totals__total-value'],
    ['#checkout, #fw-checkout-mobil', '#main-cart-footer .totals__total-value']
  ];

  function betragSetzen() {
    PAARE.forEach(function (paar) {
      var knoepfe = document.querySelectorAll(paar[0]);
      if (!knoepfe.length) return;
      var summe = document.querySelector(paar[1]);
      var text = summe ? String(summe.textContent || '').trim() : '';
      Array.prototype.forEach.call(knoepfe, function (knopf) {
        // Leerer Wert blendet das ::after aus (content: var(--fw-total, '')), statt "undefined" zu zeigen.
        if (text) knopf.style.setProperty('--fw-total', JSON.stringify(text));
        else knopf.style.removeProperty('--fw-total');
      });
    });
  }

  /* Feste Kasse-Leiste auf /cart (Paket WD5, 01.10.2026): Der Kasse-Knopf der Warenkorbseite lag mobil
   * bei 826 px, sichtbar waren 664 px. Die Leiste zeigt ihn fest am unteren Rand — und verschwindet,
   * sobald der ECHTE Knopf zur Haelfte im Bild ist (sonst staenden zwei Kasse-Knoepfe uebereinander).
   * Ohne IntersectionObserver bleibt die Leiste stehen: doppelt, aber funktionsfaehig. */
  var kasseBeobachter = null;
  function kasseLeisteSteuern() {
    if (!document.body || !document.body.classList.contains('template-cart') || !window.IntersectionObserver) return;
    var echt = document.getElementById('checkout');
    if (!echt) return;
    if (kasseBeobachter) kasseBeobachter.disconnect();
    kasseBeobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { document.body.classList.toggle('fw-kasse-echt', e.isIntersecting); });
    }, { threshold: 0.5 });
    kasseBeobachter.observe(echt);
  }

  /* Zeilen-Chip: markiert, welche Position zur Aktion gehoert — und welche noch auf ihr Partnerteil
   * wartet. Warum hier und nicht im Liquid: der Chip muesste in die Artikelschleife von
   * cart-drawer.liquid, und genau dort liegen die Anker von deploy-aktion.mjs (fa_line_gratis,
   * fa-line__badge, FYT-Filter) dicht beieinander. Diese Stelle fasst niemand an.
   *
   * 🔴 BEWUSST OHNE Paarnummer. Shopify paart die Teile selbst — bei gemischten Preisen nach der
   * guenstigsten Kombination, nicht nach der Reihenfolge im Warenkorb. Ein Chip "Paar 1" waere
   * deshalb eine Behauptung ueber fremde Logik. Gezeigt wird nur, was sicher stimmt: Zugehoerigkeit
   * und, bei ungerader Anzahl, dass ein Teil noch ohne Partner ist.
   */
  function chipsSetzen() {
    var quelle = document.querySelector('[data-fh-cart][data-fh-handles]');
    if (!quelle) return;
    var handles = (quelle.getAttribute('data-fh-handles') || '').split(',').filter(Boolean);
    if (!handles.length) return;
    var textPaar = quelle.getAttribute('data-t-chip-paar') || '';
    var textWartet = quelle.getAttribute('data-t-chip-wartet') || '';

    var zeilen = Array.prototype.slice.call(
      document.querySelectorAll('#CartDrawer .cart-item, #main-cart-items .cart-item')
    );
    var treffer = [];
    var gesamt = 0;
    zeilen.forEach(function (tr) {
      var link = tr.querySelector('a.cart-item__name');
      var m = link && /\/products\/([^?/#]+)/.exec(link.getAttribute('href') || '');
      if (!m || handles.indexOf(m[1]) === -1) return;
      var feld = tr.querySelector('.quantity__input');
      var menge = feld ? parseInt(feld.value, 10) : 1;
      if (!menge || menge < 1) menge = 1;
      gesamt += menge;
      treffer.push(tr);
    });

    zeilen.forEach(function (tr) {
      var alt = tr.querySelector('.fw-chip');
      if (alt) alt.parentNode.removeChild(alt);
    });
    if (!treffer.length) return;

    treffer.forEach(function (tr, i) {
      var ziel = tr.querySelector('.cart-item__details');
      if (!ziel) return;
      var wartet = gesamt % 2 === 1 && i === treffer.length - 1;
      var chip = document.createElement('span');
      chip.className = 'fw-chip' + (wartet ? ' fw-chip--wartet' : '');
      chip.textContent = wartet ? textWartet : textPaar;
      ziel.appendChild(chip);
    });
  }

  var geplant = false;
  function anstossen() {
    if (geplant) return;
    geplant = true;
    // Ein Frame Verzoegerung: der Austausch von .drawer__inner ist beim ersten Callback noch nicht
    // abgeschlossen, die alte Summe stuende sonst am neuen Knopf.
    requestAnimationFrame(function () {
      geplant = false;
      beobachter.disconnect();
      betragSetzen();
      chipsSetzen();
      kasseLeisteSteuern();
      lauschen();
    });
  }

  var beobachter = null;
  function lauschen() {
    // Nur childList/subtree: das Setzen der Property aendert ein Attribut und wuerde sich sonst
    // selbst erneut ausloesen. Der Beobachter wird beim Schreiben abgemeldet (Schleifenschutz),
    // weil die Chips echte Knoten einhaengen.
    beobachter.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    beobachter = new MutationObserver(anstossen);
    betragSetzen();
    chipsSetzen();
    kasseLeisteSteuern();
    lauschen();
    document.addEventListener('cart:refresh', anstossen);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
